import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=ba8fc93e&scoped=true&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Loader.vue?vue&type=style&index=0&id=ba8fc93e&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ba8fc93e",
  "6c770d38"
  
)

export default component.exports